import {
  ArrowTrendingUpIcon,
  PaintBrushIcon,
  ViewfinderCircleIcon,
} from "@heroicons/react/24/outline";
import TextIcon from "../../../components/TextIcon";
import VerticalStackIcon from "../../../components/VerticalStackIcon";
import type { FeaturesBlockData } from "../../../components/blocks/FeaturesBlock";
import { WEB_ASSET_DEMO_MEDIA } from "../../../helpers/media-landing";

// Shared landing-page feature list, consumed by both
// `app/(marketing)/home-content.tsx` and `components/Alternative.tsx`
// (rendered by every `app/(marketing)/alternatives/[slug]/page.tsx`).
//
// Lives in its own module so the alternatives routes don't transitively
// pull in the entire `home-content` module graph (Hero, Logo, dynamic
// imports, hooks, etc.) just to read the feature list. Only the data,
// icons, and `WEB_ASSET_DEMO_MEDIA` come along for the ride.
export const featuresThatMakesKlapBetter: FeaturesBlockData = {
  title: undefined,
  description: undefined,
  items: [
    {
      icon: <VerticalStackIcon />,
      title: "AI Editing",
      description:
        "AI extracts the best topics from your long video and automatically edits them into many viral-worthy clips.",
      media: WEB_ASSET_DEMO_MEDIA.aiGenerate,
    },
    {
      icon: <ViewfinderCircleIcon />,
      title: "Auto Reframing",
      description:
        "Automatically reframe your video clips to always focus on the most important subject.",
      media: WEB_ASSET_DEMO_MEDIA.framing,
    },
    {
      icon: <TextIcon />,
      title: "Engaging Captions",
      description:
        "Keep your followers engaged with beautifully designed subtitles and recommended captions to help it go viral.",
      media: WEB_ASSET_DEMO_MEDIA.captions,
    },
    {
      icon: <PaintBrushIcon />,
      title: "Customization",
      description:
        "Fully customize everything to fit the unique needs of your brand: like fonts, colors, logos, and framing.",
      media: WEB_ASSET_DEMO_MEDIA.style,
    },
    {
      icon: <ArrowTrendingUpIcon />,
      title: "Publish & Schedule",
      description:
        "Directly share your new video clips on your social media channels (TikTok, YouTube, Instagram, LinkedIn, and Facebook) and schedule them in to fit your content strategy and ultimately grow your followers.",
      media: WEB_ASSET_DEMO_MEDIA.publish,
    },
  ],
};
